import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api from "../../utils/api";
import ScrollToTop from "../../Component/ScrollToTop";

const OrderConfirmation = () => {
  const { orderId } = useParams();
  const navigate = useNavigate();
  const [order, setOrder] = useState(null);

  useEffect(() => {
    if (!orderId) {
      navigate("/Shop");
      return;
    }
    fetchOrder();
  }, [orderId]);

  const fetchOrder = async () => {
    try {
      const res = await api.get(`/api/orders/${orderId}`);
      setOrder(res.data);
    } catch (err) {
      console.log(err);
      navigate("/Shop");
    }
  };

  if (!order)
    return (
      <div className="text-center py-5">
        <ScrollToTop />
        Loading...
      </div>
    );

  return (
    <div>
      <ScrollToTop />
      <div className="container py-5">
        <div className="card shadow-sm p-4">

          <h2 className="text-success text-center mb-4">
            🎉 Order Confirmed!
          </h2>

          <div className="mb-3">
            <p><b>Order ID:</b> {order._id}</p>
            <p><b>Total:</b> ₹{order.totalPrice}</p>
            <p><b>Payment:</b> {order.paymentMethod}</p>
            <p><b>Status:</b> {order.orderStatus}</p>
          </div>

          <hr />

          <h5 className="mb-3">Ordered Products</h5>

          {order.orderItems?.map((item, index) => (
            <div
              key={index}
              className="d-flex justify-content-between border-bottom py-2"
            >
              <div>
                <b>{item.product?.name || "Product"}</b>
                <br />
                Qty: {item.qty}
              </div>
              <div>
                ₹{(item.product?.price || 0) * item.qty}
              </div>
            </div>
          ))}

          {/* ================= BUTTONS ================= */}
          <div className="text-center mt-4 d-flex justify-content-center gap-3">

            <button
              className="btn btn-primary"
              onClick={() => navigate("/my-orders")}
            >
              View My Orders
            </button>

            <button
              className="btn btn-outline-success"
              onClick={() => navigate("/Shop")}
            >
              🛒 Start Shopping
            </button>

          </div>

        </div>
      </div>
    </div>
  );
};

export default OrderConfirmation;